import React from "react";
import trophy from "assets/svg/trophy-blue-strong.svg";
import styles from "../ApplyForWC.module.css";

const LinksComponent = () => {
  return (
    <div className={styles.linksGroup}>
      <div className={styles.linkIcon}>
        <img src={trophy} alt="justworks logo" />
      </div>

      <div className={styles.linkContent}>
        <span className={styles.linkTitle}>PRO TIP</span>

        <span>Have these documents ready</span>

        <>
          <ul>
            <li>Articles of incorporation or other formation documents</li>
            <li>Loss Runs Report</li>
            <li>EPLI policy (if applicable)</li>
            <li>EPLI Loss Run Report (if applicable)</li>
          </ul>
        </>
      </div>
    </div>
  );
};

export default LinksComponent;
